/***
 * Created on 2024/1/10
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import ModalDialog from "../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";
import {useMutation} from "@tanstack/react-query";
import {apiDelete} from "../../../service/api";


function UnlinkWarningDialog({platform, socialService, ...props}) {
    const { t } = useTranslation();
    const current_platform = socialService.getPlatformName(platform);


    const social_title = t('@Disable {social_network} Login@', {
        social_network: current_platform,
        interpolation: {
            prefix: '{',
            suffix: '}',
            escapeValue: false
        }
    })

    const doUnLinkMutation = useMutation({
        mutationFn: async (data) => await apiDelete('/ajax/link_platform', data),
        onSuccess: data => {
            location.href = '/signout';
        },
        onError: (error, variables, context) => {
            console.log(error);
        }
    })

    const doUnlink = async () => {
        await socialService.unLinkPlatform(platform, doUnLinkMutation.mutateAsync);
    }

    return (
        <ModalDialog {...props} title={social_title} submitText={t('@Disable@')} submitAction={doUnlink}>
            <div className="dialog-content">
                <p>
                    {t("@After you disable the {social_network_1} login, you will no longer be able to log in using your {social_network_2} credentials. You can re-enable {social_network_3} login in the Profile settings anytime.@", {
                        social_network_1: platform,
                        social_network_2: platform,
                        social_network_3: platform,
                        interpolation: {
                            prefix: '{',
                            suffix: '}',
                            escapeValue: false
                        }
                    })}
                </p>
            </div>
        </ModalDialog>
    );
}

export default UnlinkWarningDialog;